import { render, staticRenderFns } from "./publicHead.vue?vue&type=template&id=cf053eb8&scoped=true&"
import script from "./publicHead.vue?vue&type=script&lang=js&"
export * from "./publicHead.vue?vue&type=script&lang=js&"
import style0 from "./publicHead.vue?vue&type=style&index=0&id=cf053eb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf053eb8",
  null
  
)

export default component.exports